fx.ns("desktop.print", class PrintEditor extends desktop.common.CreationEditor {
    
	constructor(data)
	{
		super(data);
	}

	contextMenu(e)
	{
        return [];
	}

    get mediaTabs()
    {
        if (!this._mediaTabs)
            this._mediaTabs = new desktop.print.MediaTabs( this.data );

        return this._mediaTabs;
    }
    
    get board()
    {
        if (!this._board)
            this._board = new desktop.print.PrintBoard(this.data, desktop.print.ComponentFactory);

        return this._board;
    }

    labelFunction()
    {
        if (this.data.print.isScrapBooking)
            return fx.text("$ photos", this.data.print.numPrints) + ", <span class='price'>" + this.data.print.totalPrice + "</span>"; 
        else
        if (this.data.print.numPrints < this.data.print.minPages)
            return fx.text("$/$ photos", this.data.print.numPrints, this.data.print.minPages) + ", <span class='price'>" + this.data.print.totalPrice + "</span>"; 
        else
            return fx.text("$ photos", this.data.print.numPrints) + ", <span class='price'>" + this.data.print.totalPrice + "</span>"; 
    }
	

    

});